import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/**
 * What the balance popover shows (Figma 15073:84638): every account in one
 * currency, or the balance of the product the page belongs to.
 */
export type BalanceDisplayMode = 'total' | 'auto';

interface BalanceDisplayState {
  mode: BalanceDisplayMode;
  /** Coin id the Total Assets hero is shown in; null → USDC. */
  assetsCoinId: string | null;
  /** Settle coin the Crypto Trading hero shows; null → the page pair's. */
  cryptoCurrency: string | null;
  setMode: (mode: BalanceDisplayMode) => void;
  setAssetsCoinId: (id: string) => void;
  setCryptoCurrency: (symbol: string) => void;
}

export const useBalanceDisplayStore = create<BalanceDisplayState>()(
  persist(
    (set) => ({
      mode: 'total',
      assetsCoinId: null,
      cryptoCurrency: null,
      setMode: (mode) => set({ mode }),
      setAssetsCoinId: (assetsCoinId) => set({ assetsCoinId }),
      setCryptoCurrency: (cryptoCurrency) => set({ cryptoCurrency }),
    }),
    {
      name: 'balance-display',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
